import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EntityState {
  prevEntity: string;
}

const initialState: EntityState = {
  prevEntity: "",
};

const entitySlice = createSlice({
  name: "entity",
  initialState,
  reducers: {
    setPrevEntity: (state, action: PayloadAction<string>) => {
      state.prevEntity = action.payload;
    },
  },
});

export const { setPrevEntity } = entitySlice.actions;
export default entitySlice.reducer;
